import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
export const NativeChartConfigComponent = ({ type, componentItem, onChangeHandler, elementKey, label, defaultValue, }) => {
    const Component = componentItem?.component;
    if (!Component) {
        return null;
    }
    switch (type) {
        case 'customsort':
            return React.createElement(Component, { ...componentItem.props });
        case 'tooltipconfig':
            return (React.createElement(FormControl, { label: label || '', noMarginBottom: true, "data-testid": `test-id-${elementKey}`, className: styles.nativeTooltipWrapper },
                React.createElement(Component, { ...componentItem.props, customChartChangeHandler: onChangeHandler, customChartSettingsElementKey: elementKey, customChartSettingsDefaultValue: defaultValue })));
        default:
            return null;
    }
};
//# sourceMappingURL=native-chart-config-form-component.js.map